import type { ToneOverlay } from "../index.js";

// Voz "dark" em português: humor negro à portuguesa — fatalismo melancólico, autoironia e
// desenrascanço, com aquele encolher de ombros. Humor próprio, não uma tradução. Opcional;
// a voz séria continua a ser a predefinição. As linhas com variantes rodam a cada duas
// horas (TONE_ROTATE_MS). Cada variante mantém os {marcadores} da base.
export const overlay: ToneOverlay = {
  "alert.toast.new": [
    "{hazard} por perto. Paciência.",
    "{hazard} por perto. É o que é.",
    "{hazard} por perto. Só cá, isto.",
    "{hazard} por perto. Avisa lá o pessoal.",
    "{hazard} por perto. Epá, a sério?",
  ],
  "alert.toast.escalation": [
    "O {hazard} foi a pior. Claro.",
    "O {hazard} piorou. Já se esperava.",
    "O {hazard} a aumentar. Valha-me Deus.",
    "O {hazard} resolveu chatear. Boa.",
  ],
  "alert.toast.inPath": [
    "O {hazard} vem direitinho a si. Fuja.",
    "O {hazard} escolheu-o a si. Que sorte a sua. Corra.",
    "O {hazard} vem aí. Hoje não, obrigado. Mexa-se.",
    "O {hazard} com o seu nome. Ponha-se a milhas.",
  ],
  "alert.toast.allClear": [
    "Ainda vivo perto de {place}. Já não é mau.",
    "{place} não o apanhou. Desta vez.",
    "Sobreviveu a {place}. Fica para a história.",
    "Tudo calmo perto de {place}. Até à próxima.",
  ],
  "alert.toast.tap": [
    "Toque para o plano de não ir desta para melhor.",
    "Toque, está aqui como continuar vivo.",
    "Toque. As instruções de respirar, lá dentro.",
  ],
  "alert.takeover.title": [
    "{hazard} — hoje o protagonista é você. Vá.",
    "{hazard} — a parte do filme em que se foge. Corra.",
    "{hazard} — aja agora, as queixas ficam para depois.",
  ],
  "alert.takeover.details": "Os pormenores macabros",
  "alert.takeover.dismiss": "Sobrevivi, fechar",
  "now.status.allClear": [
    "Ainda cá. Olha.",
    "Ainda a respirar. Já é alguma coisa.",
    "Estatisticamente, bem.",
    "Calmo. Calmo demais.",
    "Vivo e aborrecido. O ideal.",
    "Sem novidade. Por agora.",
    "Nem bem nem mal. Perfeito.",
  ],
  "now.status.stayAware": [
    "Olho vivo, que isto nunca se sabe.",
    "Não confie nem na sua sombra.",
    "Um olho aberto, por via das dúvidas.",
    "Esta é a parte calma. Aproveite.",
    "Não se descaie, então.",
    "Vá vigiando, não vá o diabo tecê-las.",
  ],
  "now.status.sub.allClear": [
    "Nada a querer matá-lo no raio. Milagre.",
    "Sem perigos por perto. Desconfie à mesma.",
    "O raio está limpo. Para já.",
    "Nada no radar. Aproveite enquanto dura.",
    "Tudo calmo. Calmo a mais.",
    "Nada à vista. O universo anda distraído.",
  ],
  "now.activity.empty": [
    "Suspeitosamente calmo, pois.",
    "Nada. Quase falta de educação.",
    "Isto está mais morto que o Agosto.",
    "Nem uma alma. Grilos.",
    "Zero notícias. Fingimos que é bom.",
    "Silêncio. Mau presságio, mas silêncio.",
  ],
  "onboarding.promise.tagline": "Vizinhos a manter vizinhos cá em cima.",
  "onboarding.promise.continue": "Vamos lá sobreviver a isto",
  "onboarding.home.browse": "Só a ver as montras do apocalipse",
  "you.voice.intro": "Escolha o sabor das más notícias.",
};
